var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"w-full mt-2",attrs:{"size":"small"},on:{"click":_vm.copy}},[_vm._v("\n  Duplicate English to Chinese\n")])}
var staticRenderFns = []

export { render, staticRenderFns }